<div class="flex justify-between gap-2 mb-3">
  <div class="flex gap-2 items-center">
    <label class="text-sm font-medium whitespace-nowrap">Usine</label>
    <p-select
      [options]="plantOptions"
      [(ngModel)]="selectedPlant"
      (onChange)="onPlantFilterChange($event.value)"
      (onClear)="onPlantFilterChange(null)"
      placeholder="Filtrer par usine"
      size="small"
      [showClear]="true"
      [style]="{ minWidth: '150px' }"
    ></p-select>
    <button
      pButton
      type="button"
      label="Effacer les filtres"
      class="p-button-sm"
      [ngClass]="
        hasActiveFilters
          ? '!bg-amber-500 !border-amber-500 hover:!bg-amber-600'
          : '!bg-gray-500/80 !border-gray-500/80 hover:!bg-gray-500/80'
      "
      (click)="onClearFilters()"
    >
      <i-lucide name="filter-x" [size]="16"></i-lucide>
    </button>
  </div>
</div>

<div
  class="w-full bg-white dark:bg-zinc-800 rounded-lg border border-gray-200 dark:border-zinc-600"
>
  <p-table
    #workNotificationTable
    [value]="workNotifications"
    [lazy]="true"
    [filters]="initialFilters"
    [loading]="loading"
    (onLazyLoad)="loadData($event)"
    [totalRecords]="totalRecords"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50, 100]"
    [paginator]="true"
    [rows]="25"
    currentPageReportTemplate="Éléments de {first} a {last} sur un total de {totalRecords}"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="w-[8%]">
          <div class="flex flex-wrap items-center justify-center w-full">
            <div class="flex items-center justify-between w-full">
              <span>Numéro d'avis</span>
              <p-sortIcon
                pSortableColumn="SAP_WorkNotificationId"
                field="SAP_WorkNotificationId"
              />
            </div>
            <div class="mt-2 w-full">
              <p-columnFilter
                [showClearButton]="false"
                type="text"
                field="SAP_WorkNotificationId"
                class="small-filter-input"
                placeholder="Filtrer par numéro"
                [style]="{ width: '100%' }"
                size="small"
              >
              </p-columnFilter>
            </div>
          </div>
        </th>

        <th class="w-[10%]">
          <div class="flex flex-wrap items-center justify-center w-full">
            <div class="flex items-center justify-between w-full">
              <span>Poste de travail</span>
              <p-sortIcon
                pSortableColumn="SAP_MainWorkCenter"
                field="SAP_MainWorkCenter"
              />
            </div>
            <div class="mt-2 w-full">
              <p-columnFilter
                class="ml-auto column-filter-full-width"
                field="SAP_MainWorkCenter"
                [showMenu]="false"
                [showClearButton]="false"
              >
                <ng-template
                  #filter
                  pTemplate="filter"
                  let-value
                  let-filter="filterCallback"
                >
                  <p-multiselect
                    [options]="mainWorkCenterOptions"
                    [style]="{ width: '100%' }"
                    [(ngModel)]="selectedMainWorkCenters"
                    (onChange)="
                      onMainWorkCenterFilterChange($event.value, filter)
                    "
                    (onClear)="onMainWorkCenterFilterChange(null, filter)"
                    placeholder="Filtrer par poste de travail"
                    [filter]="true"
                    filterPlaceholder="Rechercher..."
                    [showClear]="true"
                    appendTo="body"
                    size="small"
                  ></p-multiselect>
                </ng-template>
              </p-columnFilter>
            </div>
          </div>
        </th>

        <th class="w-[10%]">
          <div class="flex flex-wrap items-center justify-center w-full">
            <div class="flex items-center justify-between w-full">
              <span>Poste Tech</span>
              <p-sortIcon
                pSortableColumn="SAP_FunctionalLocationDescription"
                field="SAP_FunctionalLocationDescription"
              />
            </div>
            <div class="mt-2 w-full">
              <p-columnFilter
                [showClearButton]="false"
                type="text"
                field="SAP_FunctionalLocationDescription"
                class="small-filter-input"
                placeholder="Filtrer par description"
                [style]="{ width: '100%' }"
                size="small"
              >
              </p-columnFilter>
            </div>
          </div>
        </th>

        <th class="w-[10%]">
          <div class="flex flex-wrap items-center justify-center w-full">
            <div class="flex items-center justify-between w-full">
              <span>Poste Tech Id</span>
              <p-sortIcon
                pSortableColumn="SAP_FunctionalLocation"
                field="SAP_FunctionalLocation"
              />
            </div>
            <div class="mt-2 w-full">
              <p-columnFilter
                [showClearButton]="false"
                type="text"
                field="SAP_FunctionalLocation"
                class="small-filter-input"
                placeholder="Filtrer par poste tech Id"
                [style]="{ width: '100%' }"
                size="small"
              >
              </p-columnFilter>
            </div>
          </div>
        </th>

        <th class="w-[10%]">
          <div class="flex flex-wrap items-center justify-center w-full">
            <div class="flex items-center justify-between w-full">
              <span>Date de création</span>
              <p-sortIcon
                pSortableColumn="SAP_CreatedOn"
                field="SAP_CreatedOn"
              />
            </div>
            <div class="mt-2 w-full">
              <p-columnFilter
                class="ml-auto column-filter-full-width"
                field="SAP_CreatedOn"
                [showMenu]="false"
                [showClearButton]="false"
                dataType="date"
                matchMode="equals"
              >
                <ng-template
                  pTemplate="filter"
                  let-value
                  let-applyFilter="filterCallback"
                >
                  <p-datepicker
                    placeholder="Filtrer par date de creation"
                    [style]="{
                      width: '100%',
                      padding: '0',
                    }"
                    [(ngModel)]="createdOnDate"
                    (ngModelChange)="applyFilter($event)"
                    size="small"
                    class="text-sm"
                    iconDisplay="button"
                    styleClass="text-sm p-inputtext-sm"
                    selectionMode="range"
                    showIcon
                    [showButtonBar]="true"
                  >
                  </p-datepicker>
                </ng-template>
              </p-columnFilter>
            </div>
          </div>
        </th>

        <th class="w-[10%]">
          <div class="flex flex-wrap items-center justify-center w-full">
            <div class="flex items-center justify-between w-full">
              <span>Description</span>
              <p-sortIcon
                pSortableColumn="SAP_Description"
                field="SAP_Description"
              />
            </div>
            <div class="mt-2 w-full">
              <p-columnFilter
                [showClearButton]="false"
                type="text"
                field="SAP_Description"
                class="small-filter-input"
                placeholder="Filtrer par description"
                [style]="{ width: '100%' }"
                size="small"
              >
              </p-columnFilter>
            </div>
          </div>
        </th>

        <th class="w-[12%]">
          <div class="flex flex-wrap items-center justify-center w-full">
            <div class="flex items-center justify-between w-full">
              <span>Ordres Candidats</span>
            </div>
            <div class="mt-2 w-full">
              <p-columnFilter
                class="ml-auto column-filter-full-width"
                field="FilterWorkNotificationWithCandidates"
                [showMenu]="false"
                [showClearButton]="false"
              >
                <ng-template
                  #filter
                  pTemplate="filter"
                  let-value
                  let-filter="filterCallback"
                >
                  <p-select
                    [options]="ordersCandidatesFilterOptions"
                    [style]="{ width: '100%' }"
                    (onChange)="filter($event.value)"
                    placeholder="Filtrer"
                    size="small"
                  ></p-select>
                </ng-template>
              </p-columnFilter>
            </div>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-notification>
      <tr>
        <td class="text-center">
          <span>
            {{ notification.SAP_WorkNotificationId }}
          </span>
        </td>
        <td class="text-center">
          {{ notification.SAP_MainWorkCenter }}
        </td>
        <td class="text-left">
          <span [title]="notification.SAP_FunctionalLocationDescription || ''">
            {{ notification.SAP_FunctionalLocationDescription || "-" }}
          </span>
        </td>
        <td class="text-left">
          <span [title]="notification.SAP_FunctionalLocation || ''">
            {{ notification.SAP_FunctionalLocation || "-" }}
          </span>
        </td>
        <td class="text-center">
          {{ notification.SAP_CreatedOn | date: "yyyy/MM/dd" }}
        </td>
        <td class="text-left">
          <span [title]="notification.SAP_Description || ''">
            {{ notification.SAP_Description || "-" }}
          </span>
        </td>

        <td>
          <div class="flex flex-wrap gap-2 items-center">
            <span
              *ngFor="let candidate of notification?.WorkOrderCandidates"
              [pTooltip]="
                'Ordre de travail candidat: ' +
                candidate?.Candidate_SAP_WorkOrderId +
                ' (Confiance: ' +
                (candidate?.ConfidenceScore * 100 | number: '1.0-0') +
                '%' +
                ')'
              "
              tooltipPosition="top"
              [escape]="false"
              [appendTo]="'body'"
              tooltipStyleClass="similar-order-tooltip"
              class="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-semibold cursor-pointer transition-all duration-200 text-white"
              [ngClass]="getConfidenceScoreClass(candidate?.ConfidenceScore)"
              (click)="onCandidateClick(candidate, $event)"
            >
              {{ candidate.Candidate_SAP_WorkOrderId }}
            </span>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" class="text-center py-8">
          <div class="flex flex-col items-center justify-center">
            <lucide-icon
              name="inbox"
              class="w-12 h-12 text-gray-400 mb-2"
            ></lucide-icon>
            <span class="text-gray-500 dark:text-zinc-400"
              >Aucun avis de travail trouvé</span
            >
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-popover #candidatePopover [dismissable]="true" [autoZIndex]="true">
  <div class="min-w-64">
    <div *ngIf="selectedCandidate" class="pt-3">
      <div class="space-y-2 text-sm">
        <div class="grid grid-cols-2 gap-4 mb-3 pb-2 border-b">
          <div>
            <div class="text-gray-500 text-xs mb-1">Avis de travail</div>
            <div class="text-gray-800 font-semibold">
              {{ selectedCandidate.WorkNotificationId }}
            </div>
          </div>
          <div>
            <div class="text-gray-500 text-xs mb-1">Ordre candidat</div>
            <div class="text-gray-800 font-semibold">
              {{ selectedCandidate.Candidate_SAP_WorkOrderId }}
            </div>
          </div>
        </div>
        <div>
          <div class="text-gray-500">Description</div>
          <div class="text-gray-800 font-medium">
            {{ selectedCandidate.CandidateWorkOrder?.SAP_Description || "-" }}
          </div>
        </div>

        <div class="grid grid-cols-3 gap-4">
          <div class="flex flex-col items-center">
            <div class="text-gray-600 block mb-2">Catégorie</div>
            <span
              class="px-4 py-1.5 rounded-full text-sm font-semibold bg-gray-400 text-white"
            >
              {{
                selectedCandidate.CandidateWorkOrder?.SAP_WorkOrderType || "-"
              }}
            </span>
          </div>
          <div class="flex flex-col items-center">
            <div class="text-gray-500 block mb-2">Confience</div>
            <div
              class="px-4 py-1.5 rounded-full text-sm font-semibold text-white"
              [ngClass]="
                getConfidenceScoreClass(selectedCandidate.ConfidenceScore)
              "
            >
              {{ selectedCandidate.ConfidenceScore * 100 | number: "1.0-0" }}%
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-popover>
